import {
  MilestoneDescriptions,
  MilestoneTemplate
} from '@/store/types/milestone'

export function mileStoneDescriptionActions (
  descriptionsOfSubMilestones: MilestoneDescriptions[],
  milestone: MilestoneTemplate,
  action: 'toggle' | 'getDescription' | 'isShowing'
): string | void | boolean {
  const description = descriptionsOfSubMilestones.find(
    (description: MilestoneDescriptions) => milestone.id === description.id
  )
  if (description) {
    switch (action) {
      case 'toggle':
        description.show = !description.show
        return
      case 'getDescription':
        return description.description
      case 'isShowing':
        return description.show && description.description
    }
  }
}
